import { withTitle } from '@gik/core/hocs/withTitle';
import { UserProfile } from '@gik/user-profile/components/UserProfile/UserProfile';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';

export default function UserProfilePageComp() {
  return withTitle('Profile', <UserProfile />);
}

UserProfilePageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};
